import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import brandPortalConfirmIdentityBrandIdvToken from "@faire/web-api/routes/brand-portal/confirm-identity/brandIDVToken";
import brandPortalMarketingInsiderPartnership from "@faire/web-api/routes/brand-portal/marketing/insider-partnership";
import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { path as getBrandOrderFulfillmentRoute } from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-fulfilment";
import brandPortalOrdersbrandOrderTokenOrderInvoice from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-invoice";
import { path as requestCommissionUpdatePath } from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/request-commission-update";
import brandPortalPayouts from "@faire/web-api/routes/brand-portal/payouts";
import supportBrands from "@faire/web-api/routes/support/brands";
export var GoToOrderFulfillmentCTA = function GoToOrderFulfillmentCTA(brandOrderToken, strictLocalize) {
  return {
    label: strictLocalize({
      id: "jADdIM",
      defaultMessage: "Go to Order Fulfillment"
    }),
    getLink: function getLink() {
      return getBrandOrderFulfillmentRoute(brandOrderToken);
    }
  };
};
export var ViewOrderDetailsInFulfillmentCTA = function ViewOrderDetailsInFulfillmentCTA(brandOrderToken, strictLocalize) {
  return {
    label: strictLocalize({
      id: "d/5WQ/",
      defaultMessage: "View order details"
    }),
    getLink: function getLink() {
      return getBrandOrderFulfillmentRoute(brandOrderToken);
    }
  };
};
export var GoToAccountSettingsCTA = function GoToAccountSettingsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "kzFvXG",
      defaultMessage: "Go to Account Settings"
    }),
    getLink: function getLink() {
      return brandPortalAccountRoute({
        tab: "my-account"
      });
    }
  };
};
export var SubmitVerificationInformationCTA = function SubmitVerificationInformationCTA(brandIdvToken, strictLocalize) {
  return {
    label: strictLocalize({
      id: "Tckfyz",
      defaultMessage: "Submit information"
    }),
    getLink: function getLink() {
      return brandPortalConfirmIdentityBrandIdvToken(brandIdvToken);
    }
  };
};
export var GoToBillingCTA = function GoToBillingCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "IVP3T9",
      defaultMessage: "Go to Billing Settings"
    }),
    getLink: function getLink() {
      return brandPortalAccountRoute({
        tab: "billing"
      });
    }
  };
};
export var ViewPayoutsCTA = function ViewPayoutsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "eVLMpT",
      defaultMessage: "View payouts"
    }),
    getLink: function getLink() {
      return brandPortalPayouts();
    }
  };
};
export var ViewOrdersCTA = function ViewOrdersCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "4ABral",
      defaultMessage: "View orders"
    }),
    getLink: function getLink() {
      return brandPortalOrders();
    }
  };
};
export var BecomeInsiderCTA = function BecomeInsiderCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "6FZzwv",
      defaultMessage: "Become an Insider Partner"
    }),
    getLink: function getLink() {
      return brandPortalMarketingInsiderPartnership();
    }
  };
};
export var GoToPayoutSettingsCTA = function GoToPayoutSettingsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "f2DPkP",
      defaultMessage: "Go to Payout Settings"
    }),
    getLink: function getLink() {
      return brandPortalAccountRoute({
        tab: "payment"
      });
    }
  };
};
export var GoToNotificationSettingsCTA = function GoToNotificationSettingsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "ODHpKV",
      defaultMessage: "Go to Notification Settings"
    }),
    getLink: function getLink() {
      return brandPortalAccountRoute({
        tab: "notifications"
      });
    }
  };
};
export var GoToHelpCenterCTA = function GoToHelpCenterCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "9G4Z05",
      defaultMessage: "Go to Help Center"
    }),
    getLink: function getLink() {
      return supportBrands();
    }
  };
};
export var GoToOrdersCTA = function GoToOrdersCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "VdSjZJ",
      defaultMessage: [{
        "type": 0,
        "value": "Go to orders"
      }]
    }),
    getLink: function getLink() {
      return brandPortalOrders();
    }
  };
};
export var ViewInvoiceCTA = function ViewInvoiceCTA(brandOrderToken, strictLocalize) {
  return {
    label: strictLocalize({
      id: "kKl0tx",
      defaultMessage: [{
        "type": 0,
        "value": "View invoice"
      }]
    }),
    getLink: function getLink() {
      return brandPortalOrdersbrandOrderTokenOrderInvoice(brandOrderToken);
    }
  };
};
export var ViewOrderDetailsCTA = function ViewOrderDetailsCTA(brandOrderToken, strictLocalize) {
  return {
    label: strictLocalize({
      id: "d/5WQ/",
      defaultMessage: "View order details"
    }),
    getLink: function getLink() {
      return brandPortalOrdersbrandOrderToken(brandOrderToken);
    }
  };
};
export var RequestCommissionChangeCTA = function RequestCommissionChangeCTA(brandOrderToken, strictLocalize) {
  return {
    label: strictLocalize({
      id: "hwyHoV",
      defaultMessage: "Request commission change"
    }),
    getLink: function getLink() {
      return requestCommissionUpdatePath(brandOrderToken);
    }
  };
};
export var UpdateTaxInformationCTA = function UpdateTaxInformationCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "NcDbgP",
      defaultMessage: "Update tax information"
    }),
    getLink: function getLink() {
      return brandPortalAccountRoute({
        tab: "export-and-taxes"
      });
    }
  };
};